import "./Tagline.css";

export default function Tagline() {
  return (
    <>
      <section className="tag-line">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="tag-line-content">
                <h2>
                  Your Assurance of Quality <br className="d-lg-none" /> our
                  Commitment to Authenticity
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
